import {strictCoreEmitter, StrictCoreEvents} from '@gongxigames/framework/core/globals';
import type {GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals/strictGameEmitter';
import {StrictEventEmitter} from '@gongxigames/framework/core/services/strictEventEmitter';
import {FlowEvents} from '@gongxigames/framework/slot';
import {UIStateName} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStatesMap';
import {UIEventMapSounds} from '../../services/sound/soundEvents';
import {BetControlEvents} from '@gongxigames/framework/slotV2/services/BetControl/BetControlEvents';
import {TurboControlEvents} from '@gongxigames/framework/slotV2/services/TurboControl/TurboControlEvents';
import {PromotionEvents, CounterData} from '@gongxigames/framework/promotions';

type UIEventMap =
    UIEventMapSounds &
    BetControlEvents &
    TurboControlEvents &
{
    'General.disableSpinButton': void;
    'General.enableSpinButton': void;
    'UI.playTransitionToFreeSpins': void;
    'UI.playTransitionToMainGame': void;
    'UI.startHoldForTurboLabelTimer': void;
    'UI.holdForTurboActivated': void;
    'UI.holdForTurboDeactivated': void;
    'UI.enableSpinAutoMode': void;
    'UI.disableSpinAutoMode': void;
    'UI.showTurboModeHint': void;
    'UI.showBetSelectPopup': boolean|void;
    'UI.IOSScroll.Activate': void;
    'UI.IOSScroll.Deactivate': void;
    'UI.IOSScroll.Show': void;
    'UI.IOSScroll.Hide': void;

    'UI.updateUIElementsState': UIStateName ;

    'UI.autoplayOptions.Close': void;
    'UI.autoplayOptions.QuickSpin': boolean;
    'UI.autoplayOptions.TurboSpin': boolean;
    'UI.autoplayOptions.UntilBonus': boolean;
    'UI.autoplayOptions.SingleWin': number | null;
    'UI.autoplayOptions.WinLimit': number | null;
    'UI.autoplayOptions.LossLimit': number | null;
    'UI.autoplayOptions.StartAutoplay': number;

    'UI.menu.infoPageClicked': void;
    'UI.menu.closed': void;
    'UI.menu.opened': void;
    'UI.menu.gameRulesClicked': void;
    'UI.menu.historyButtonClicked': void;
    'UI.menu.logoutButtonClicked': void;
    'UI.menu.supportButtonClicked': void;
    'UI.menu.cashierClicked': void;
    'UI.menu.menuBarClosed': void;

    'UI.gameRules.opened': void;
    'UI.gameRules.closed': void;
    'UI.infoPage.opened': void;
    'UI.infoPage.closed': void;
    'UI.gameHistory.opened': void;
    'UI.gameHistory.closed': void;

    'UI.specialZone.relocate': void;

    // from ui modules
    'UI.spinButton.pressed': void;
    'UI.spinButton.pointerout': void;
    'UI.skipButton.pressed': void;
    'UI.quickStopButton.pressed': void;
    'UI.bet.increase': void;
    'UI.bet.hide': void;
    'UI.bet.show': void;
    'UI.bet.decrease': void;
    'UI.bet.setByIndex': number;
    'UI.stopAutoplayButton.pressed': void;
    'UI.autoplayButton.pressed': void;
    'UI.holdSpinForAction.started': void;
    'UI.holdSpinForAction.finished': void;

    'UI.buyFeature.bet.increase': void;
    'UI.buyFeature.bet.decrease': void;
    'UI.buyFeature.bet.reSet': void;
    'UI.buyFeature.bet.started': void;
    'UI.buyFeature.bet.finished': void;

    'UI.buyFeature.open': void;
    'UI.buyFeature.buy': void;
    'UI.buyFeature.decline': void;
    'UI.buyFeature.close': void;

    // from integrations
    'Integration.enableSpinButton': void;
    'Integration.disableSpinButton': void;
    'LogicEvents.BALANCE_UPDATED': number;
    'LogicEvents.POINTS_BALANCE_UPDATED': number;

    // 'General.Game.STARTED': void;
    'General.FreeGames.UpdateCounter': CounterData;
};

export type StrictUiEmitterEventMap = StrictCoreEvents & GameOnlyEventMap & UIEventMap & FlowEvents & PromotionEvents;
export const strictUiEmitter = strictCoreEmitter as any as StrictEventEmitter<StrictUiEmitterEventMap>;
